import { CellIcon } from './CellIcon';

class NormalCellIcon extends CellIcon {

}

export {
  NormalCellIcon,
};
